import "~/sentry";
import "~/like";
import "~/suggest_usernames";
import "~/suggestion_button";
import "~/hide_flash_messages";
import "~/depends_on";

import React from "react";
import { createRoot } from "react-dom/client";

import { ChecklistRoot } from "../checklist_page";
import "../copy_checklist_to_clipboard";
import "../data_confirm";

import { store } from "store";
import { Provider } from "react-redux";
import { onChecklistPageLoad } from "helpers";

onChecklistPageLoad(() => {
  const reactContainer = document.getElementById("react-root-element");
  if (reactContainer) {
    const reactRootElement = createRoot(reactContainer);
    reactRootElement.render(
      <Provider store={store}>
        <ChecklistRoot />
      </Provider>,
    );
  }
});
